 // ========== STATE ==========
    let currentSection = 1;
    let logoFile = null;
    let photoFiles = [];

    // ========== NAVIGATION ==========
    function goToSection(target) {
      // Validate current section before moving forward
      if (target > currentSection && !validateSection(currentSection)) {
        return;
      }

      // Hide current, show target
      document.querySelector(`.form-section[data-section="${currentSection}"]`).classList.remove('active');
      document.querySelector(`.form-section[data-section="${target}"]`).classList.add('active');
      currentSection = target;
      updateProgress();

      // Scroll to top of form
      document.getElementById('progressBar').scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateProgress() {
      document.querySelectorAll('.progress-step').forEach(step => {
        const s = parseInt(step.dataset.step);
        step.classList.remove('active', 'completed');
        if (s === currentSection) step.classList.add('active');
        if (s < currentSection) step.classList.add('completed');
      });
      document.querySelectorAll('.step-connector').forEach(conn => {
        const c = parseInt(conn.dataset.connector);
        conn.classList.toggle('active', c < currentSection);
      });
    }

    // ========== VALIDATION ==========
    function validateSection(section) {
      let valid = true;

      if (section === 1) {
        valid = validateField('companyName') & validateField('contactName') & validateField('phone') & validateEmail() & validateField('postcode');
      }

      if (section === 2) {
        valid = validateCheckboxGroup('regions', 'regionsError') & validateCheckboxGroup('installTypes', 'installTypesError') & validateSelect('leadTime');
      }

      return valid;
    }

    function validateField(id) {
      const input = document.getElementById(id);
      const error = document.getElementById(id + 'Error');
      if (!input.value.trim()) {
        input.classList.add('field-error');
        if (error) error.classList.add('visible');
        return false;
      }
      input.classList.remove('field-error');
      if (error) error.classList.remove('visible');
      return true;
    }

    function validateEmail() {
      const input = document.getElementById('email');
      const error = document.getElementById('emailError');
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(input.value.trim())) {
        input.classList.add('field-error');
        error.classList.add('visible');
        return false;
      }
      input.classList.remove('field-error');
      error.classList.remove('visible');
      return true;
    }

    function validateCheckboxGroup(name, errorId) {
      const checked = document.querySelectorAll(`input[name="${name}"]:checked`);
      const error = document.getElementById(errorId);
      if (checked.length === 0) {
        error.classList.add('visible');
        return false;
      }
      error.classList.remove('visible');
      return true;
    }

    function validateSelect(id) {
      const select = document.getElementById(id);
      const error = document.getElementById(id + 'Error');
      if (!select.value) {
        select.classList.add('field-error');
        error.classList.add('visible');
        return false;
      }
      select.classList.remove('field-error');
      error.classList.remove('visible');
      return true;
    }

    // Clear errors on input
    document.querySelectorAll('input, select, textarea').forEach(el => {
      const events = el.tagName === 'SELECT' ? ['input', 'change'] : ['input'];
      events.forEach(evt => {
        el.addEventListener(evt, () => {
          el.classList.remove('field-error');
          const error = document.getElementById(el.id + 'Error');
          if (error) error.classList.remove('visible');
        });
      });
    });

    // ========== CHECKBOX STYLING ==========
    document.querySelectorAll('.checkbox-item input[type="checkbox"]').forEach(cb => {
      cb.addEventListener('change', () => {
        cb.closest('.checkbox-item').classList.toggle('checked', cb.checked);

        // Handle "Other" checkbox for install types
        if (cb.value === 'Other') {
          document.getElementById('otherTypeField').classList.toggle('visible', cb.checked);
        }

        // Clear group errors
        const name = cb.name;
        const errorId = name + 'Error';
        const error = document.getElementById(errorId);
        if (error) {
          const checked = document.querySelectorAll(`input[name="${name}"]:checked`);
          if (checked.length > 0) error.classList.remove('visible');
        }
      });
    });

    // ========== FILE UPLOADS ==========
    // Logo
    document.getElementById('logoUpload').addEventListener('change', function(e) {
      const file = e.target.files[0];
      if (!file) return;
      if (file.size > 5 * 1024 * 1024) {
        alert('Logo file must be under 5 MB');
        return;
      }
      logoFile = file;
      const preview = document.getElementById('logoPreview');
      preview.innerHTML = '';
      const reader = new FileReader();
      reader.onload = function(ev) {
        const div = document.createElement('div');
        div.className = 'upload-preview-item';
        div.innerHTML = `<img src="${ev.target.result}" alt="Logo"><button type="button" class="remove-btn" onclick="removeLogo()">&times;</button>`;
        preview.appendChild(div);
      };
      reader.readAsDataURL(file);
    });

    function removeLogo() {
      logoFile = null;
      document.getElementById('logoUpload').value = '';
      document.getElementById('logoPreview').innerHTML = '';
    }

    // Photos
    document.getElementById('photosUpload').addEventListener('change', function(e) {
      const files = Array.from(e.target.files);
      const totalAllowed = 3 - photoFiles.length;
      const toAdd = files.slice(0, totalAllowed);

      toAdd.forEach(file => {
        if (file.size > 5 * 1024 * 1024) {
          alert(`${file.name} is over 5 MB and was skipped`);
          return;
        }
        photoFiles.push(file);
      });

      if (files.length > totalAllowed) {
        alert('Maximum 3 photos allowed. Only the first ' + totalAllowed + ' were added.');
      }

      renderPhotosPreviews();
      e.target.value = '';
    });

    function renderPhotosPreviews() {
      const preview = document.getElementById('photosPreview');
      preview.innerHTML = '';
      photoFiles.forEach((file, idx) => {
        const reader = new FileReader();
        reader.onload = function(ev) {
          const div = document.createElement('div');
          div.className = 'upload-preview-item';
          div.innerHTML = `<img src="${ev.target.result}" alt="Photo ${idx+1}"><button type="button" class="remove-btn" onclick="removePhoto(${idx})">&times;</button>`;
          preview.appendChild(div);
        };
        reader.readAsDataURL(file);
      });
    }

    function removePhoto(idx) {
      photoFiles.splice(idx, 1);
      renderPhotosPreviews();
    }

    // ========== FORM SUBMISSION ==========
    document.getElementById('installerForm').addEventListener('submit', function(e) {
      e.preventDefault();

      // Validate all sections
      if (!validateSection(1)) { goToSection(1); return; }
      if (!validateSection(2)) { goToSection(2); return; }

      // Gather data
      const companyName = document.getElementById('companyName').value.trim();
      const contactName = document.getElementById('contactName').value.trim();
      const email = document.getElementById('email').value.trim();
      const phone = document.getElementById('phone').value.trim();
      const postcode = document.getElementById('postcode').value.trim();

      const regions = Array.from(document.querySelectorAll('input[name="regions"]:checked')).map(cb => cb.value);
      const installTypes = Array.from(document.querySelectorAll('input[name="installTypes"]:checked')).map(cb => cb.value);
      const otherType = document.getElementById('otherTypeText').value.trim();
      const leadTime = document.getElementById('leadTime').value;

      const website = document.getElementById('website').value.trim();
      const minJobSize = document.getElementById('minJobSize').value.trim();

      // Build email body
      let body = '';
      body += '=== INSTALLER MAP REGISTRATION ===\n\n';
      body += '--- COMPANY DETAILS ---\n';
      body += `Company: ${companyName}\n`;
      body += `Contact: ${contactName}\n`;
      body += `Email: ${email}\n`;
      body += `Phone: ${phone}\n`;
      body += `Base Location: ${postcode}\n\n`;
      body += '--- COVERAGE & SERVICES ---\n';
      body += `Regions: ${regions.join(', ')}\n`;
      body += `Install Types: ${installTypes.join(', ')}`;
      if (installTypes.includes('Other') && otherType) {
        body += ` (Other: ${otherType})`;
      }
      body += `\n`;
      body += `Lead Time: ${leadTime}\n\n`;
      body += '--- OPTIONAL EXTRAS ---\n';
      body += `Website: ${website || 'Not provided'}\n`;
      body += `Min Job Size: ${minJobSize || 'Not provided'}\n`;
      body += `Logo Uploaded: ${logoFile ? 'Yes (' + logoFile.name + ')' : 'No'}\n`;
      body += `Photos Uploaded: ${photoFiles.length > 0 ? photoFiles.length + ' photo(s): ' + photoFiles.map(f => f.name).join(', ') : 'None'}\n\n`;
      body += '---\n';
      body += 'Note: If logo/photos were selected, the installer should be asked to email them separately or they can be collected via a follow-up.\n';

      // Also submit to Formsubmit.co (no-AJAX fallback)
      // We'll use the Formsubmit approach for reliable delivery
      submitViaFormsubmit({
        companyName, contactName, email, phone, postcode,
        regions: regions.join(', '),
        installTypes: installTypes.join(', ') + (installTypes.includes('Other') && otherType ? ' (Other: ' + otherType + ')' : ''),
        leadTime, website, minJobSize,
        logoUploaded: logoFile ? 'Yes (' + logoFile.name + ')' : 'No',
        photosUploaded: photoFiles.length > 0 ? photoFiles.length + ' photo(s)' : 'None'
      });

      // Also open mailto as backup
      const subject = encodeURIComponent(`Installer Map Registration — ${companyName}`);
      const mailBody = encodeURIComponent(body);
      const mailtoLink = `mailto:info@gym-flooring.com?subject=${subject}&body=${mailBody}`;

      // Show success
      showSuccess();

      // Attempt mailto in background (won't work on all devices, so Formsubmit is primary)
      // We create a hidden link and don't click it — Formsubmit handles delivery
    });

    function submitViaFormsubmit(data) {
      // Use Formsubmit.co for reliable email delivery
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = 'https://formsubmit.co/info@gym-flooring.com';
      form.target = 'hidden-iframe';
      form.style.display = 'none';

      // Formsubmit config fields
      addHiddenField(form, '_subject', 'Installer Map Registration — ' + data.companyName);
      addHiddenField(form, '_template', 'table');
      addHiddenField(form, '_captcha', 'false');
      addHiddenField(form, '_autoresponse', 'Thank you for registering for the Sprung UK Installer Map! We\'ve received your details and will be in touch within a few working days to confirm your listing. — The Sprung Gym Flooring Team');

      // Data fields
      addHiddenField(form, 'Company Name', data.companyName);
      addHiddenField(form, 'Contact Name', data.contactName);
      addHiddenField(form, 'Email', data.email);
      addHiddenField(form, 'Phone', data.phone);
      addHiddenField(form, 'Base Location', data.postcode);
      addHiddenField(form, 'Regions Covered', data.regions);
      addHiddenField(form, 'Install Types', data.installTypes);
      addHiddenField(form, 'Lead Time', data.leadTime);
      addHiddenField(form, 'Website', data.website || 'Not provided');
      addHiddenField(form, 'Min Job Size', data.minJobSize || 'Not provided');
      addHiddenField(form, 'Logo Uploaded', data.logoUploaded);
      addHiddenField(form, 'Photos Uploaded', data.photosUploaded);

      // Create hidden iframe
      let iframe = document.getElementById('hidden-iframe');
      if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.name = 'hidden-iframe';
        iframe.id = 'hidden-iframe';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);
      }

      document.body.appendChild(form);
      form.submit();
      form.remove();
    }

    function addHiddenField(form, name, value) {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    function showSuccess() {
      document.getElementById('installerForm').style.display = 'none';
      document.getElementById('progressBar').style.display = 'none';
      document.getElementById('successScreen').classList.add('active');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

(function () {
  const head = document.head;

  // Preconnect to Google Fonts
  const preconnect1 = document.createElement("link");
  preconnect1.rel = "preconnect";
  preconnect1.href = "https://fonts.googleapis.com";
  head.appendChild(preconnect1);

  const preconnect2 = document.createElement("link");
  preconnect2.rel = "preconnect";
  preconnect2.href = "https://fonts.gstatic.com";
  preconnect2.crossOrigin = "anonymous";
  head.appendChild(preconnect2);

  // Load Inter font
  const fontStylesheet = document.createElement("link");
  fontStylesheet.rel = "stylesheet";
  fontStylesheet.href = "https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap";
  head.appendChild(fontStylesheet);
})();